angular.module('app').run(($rootScope, $window, $translate, $timeout, $sessionStorage, $injector, preloaders, variables, app, PrintToConsole) => {
    PrintToConsole.init();

    // fastclick (eliminate the 300ms delay between a physical tap and the firing of a click event on mobile browsers)
    FastClick.attach(document.body);

    $rootScope.appVer = app.version;
    $rootScope.debug = app.debug;
    $rootScope.$session = $sessionStorage.$default({
        area: {},
    });
    $rootScope.mainTheme = variables.default_theme;
    $rootScope.highContrastActive = variables.default_high_contrast;
    $rootScope.miniSidebarActive = variables.default_mini_sidebar;
    $rootScope.boxedLayoutActive = variables.default_boxed_layout;

    // wstrzykujemy usługi aby zapobiec pętli zależności
    $injector.invoke((UserService, selectize) => {
        UserService.setupUser();
        selectize.initConfig();
    });

    // input mask
    $timeout(() => {
        Inputmask.extendAliases({
            currency_pln: {
                alias: 'currency',
                prefix: 'PLN ',
                autoUnmask: true,
            },
            'gg:mm': {
                alias: 'hh:mm',
                placeholder: 'gg:mm',
                separator: ':',
            },
            'rrrr-mm-dd': {
                alias: 'yyyy-mm-dd',
                placeholder: 'rrrr-mm-dd',
                separator: '-',
            },
        });
    });

    // json
    $rootScope.json = (data) => {
        if ('string' === typeof data) {
            return angular.fromJson(data);
        } else {
            return angular.toJson(data);
        }
    };

    // get window width
    const w = angular.element($window);
    $rootScope.largeScreen = w.width() >= 1220;

    w.on('resize', () => {
        const width = w.width();
        variables.mobileMode = width < 1100;
        $rootScope.largeScreen = width >= 1220;
    });

    // show/hide main menu on page load
    $rootScope.primarySidebarOpen = !!$rootScope.largeScreen;
    $rootScope.pageLoading = true;
    $rootScope.goBack = () => {
        $window.history.go(-1);
    };

    // false dla <x a=0 b=false> true dla <x c>
    $rootScope.isParamFalse = (value) => {
        const isUndefined = 'undefined' === typeof value;
        const isZero = 0 === value || 0.0 === value;
        const isFalse = 'false' === value;
        const isEmpty = '' === value;

        return isUndefined || isZero || isFalse || !isEmpty;
    };

    if (!app.debug) {
        $window.onbeforeunload = (e) => {
            if (!e) e = window.event;
            e.cancelBubble = true;
            e.returnValue = $translate.instant('system.sure_to_leave');

            if (e.stopPropagation) {
                e.stopPropagation();
                e.preventDefault();
            }
        };
    }
});
